import type { MotorStatusApiResponse } from '@/types/site';
import { XHRAuthorizedClient } from '../client';
import { ENDPOINTS } from '../endpoints';

export const fetchMotorStatus = async (siteId: string) => {
  const response = await XHRAuthorizedClient.get<MotorStatusApiResponse>(
    ENDPOINTS.dashboard.motorStatus(siteId)
  );

  return response.data.data;
};
